import { render, staticRenderFns } from "./PayMethodEditor.vue?vue&type=template&id=794f42d8&"
import script from "./PayMethodEditor.vue?vue&type=script&lang=js&"
export * from "./PayMethodEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports